import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const SOURCES_LIST = "sources_list";
export const CREATE_SOURCES = "create_sources";
export const UPDATE_SOURCES = "update_sources";
export const DELETE_SOURCES = "delete_sources";
export const GET_SOURCES_DETAILS = "get_sources_details";
export const SOURCES_SIMPLE_LIST = "sources_simple_details";
export const CLEAR_SOURCES_ERRORS = "clearSourcesErrors";

// mutation types
export const SET_SOURCES_ERROR = "setSourcesErrors";
export const REMOVE_SOURCES_ERRORS = "removeSourcesErrors";

const state = {
    errors: null
};
const actions = {
    [SOURCES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/sources?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_SOURCES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_SOURCES_ERROR, response.errors);
                });
        });
    },
    [CREATE_SOURCES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createsource", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_SOURCES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_SOURCES_ERROR, response.errors);
                });
        });
    },
    [UPDATE_SOURCES](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatesource", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_SOURCES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_SOURCES_ERROR, response.errors);
                });
        });
    },
    [DELETE_SOURCES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletesource", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_SOURCES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_SOURCES_ERROR, response.errors);
                });
        });
    },
    [GET_SOURCES_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getsourcedetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_SOURCES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_SOURCES_ERROR, response.errors);
                });
        });
    },
    [CLEAR_SOURCES_ERRORS](context) {
        context.commit(REMOVE_SOURCES_ERRORS);
    },
    [SOURCES_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/sourcessimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
};

const mutations = {
    [SET_SOURCES_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_SOURCES_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
